'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Map as ImmutableMap } from 'immutable';
import { EXCLUDED_FORM_FIELDS } from 'MeetingsLib/constants/enums';
export var mapFalsyParamsToNull = function mapFalsyParamsToNull(_ref) {
  var params = _ref.params;
  return Object.keys(params).reduce(function (acc, key) {
    return Object.assign({}, acc, _defineProperty({}, key, params[key] || null));
  }, {});
};
export var constructFormState = function constructFormState(formFieldUrlParams) {
  var firstName;
  var lastName;
  var email;
  var paramsAsMap = ImmutableMap(formFieldUrlParams);
  var customFormFields = paramsAsMap.reduce(function (acc, val, originalKey) {
    var key = originalKey.toLowerCase();

    if (key === 'firstname') {
      firstName = val;
    } else if (key === 'lastname') {
      lastName = val;
    } else if (key === 'email') {
      email = val;
    } else if (EXCLUDED_FORM_FIELDS.indexOf(key) === -1) {
      acc[originalKey] = val;
    }

    return acc;
  }, {});
  return {
    firstName: firstName,
    lastName: lastName,
    email: email,
    customFormFields: customFormFields
  };
};